import { date } from 'quasar'

export const formatPrice = (value: number | string) => {
  const num = Number(value)

  const hasFraction = !Number.isInteger(num)
  return `${new Intl.NumberFormat('ru-RU', { minimumFractionDigits: hasFraction ? 2 : 0, maximumFractionDigits: 2 }).format(Number(value))} ₽`
}

export const humanFormatDate = (value: Date | number | string | undefined) =>
  date.formatDate(value, 'DD.MM.YYYY')
